import React from 'react';
import { remoteManagementRoute } from '@/modules/remote-management/route';
import { createRoute } from '@tanstack/react-router';

export const remoteManagementIndexRoute = createRoute({
  getParentRoute: () => remoteManagementRoute,
  path: '/',
  component: React.lazy(async () => await import('@/app/routes/RemoteManagement')),
  wrapInSuspense: true,
});
